
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns112c43b2d6ec45c53cff19777905b782en from './en.yaml'
            i18n.addResourceBundle('en', '112c43b2d6ec45c53cff19777905b782', flattenObject(ns112c43b2d6ec45c53cff19777905b782en), true, true);
        
        export default '112c43b2d6ec45c53cff19777905b782';
    